module.exports = __webpack_public_path__ + "img/img6_2.e091a095.jpeg";